'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./Ghost.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Ghost = function (_Component) {
  _inherits(Ghost, _Component);

  function Ghost() {
    _classCallCheck(this, Ghost);

    return _possibleConstructorReturn(this, (Ghost.__proto__ || Object.getPrototypeOf(Ghost)).apply(this, arguments));
  }

  _createClass(Ghost, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        { className: 'ax-ghost', viewBox: '0 0 132 186' },
        _react2.default.createElement(
          'defs',
          null,
          _react2.default.createElement(
            'mask',
            { id: 'hole' },
            _react2.default.createElement('rect', { fill: 'white', height: '100%', width: '100%' }),
            _react2.default.createElement('circle', { cx: '36', cy: '36', r: '36', transform: 'translate(30, 48)' })
          )
        ),
        _react2.default.createElement('circle', { className: 'ax-ghost__background', cx: '36', cy: '36', r: '36', transform: 'translate(30, 48)' }),
        _react2.default.createElement(
          'g',
          { className: 'ax-ghost__character', transform: 'translate(42, 68)' },
          _react2.default.createElement('rect', {
            className: 'ax-ghost__body',
            height: '69',
            rx: '24',
            width: '48',
            x: '0',
            y: '0' }),
          _react2.default.createElement(
            'g',
            { transform: 'translate(12, 15)' },
            _react2.default.createElement('circle', { className: 'ax-ghost__eye', cx: '21', cy: '5', r: '5' }),
            _react2.default.createElement('circle', { className: 'ax-ghost__eye', cx: '5', cy: '5', r: '5' })
          ),
          _react2.default.createElement(
            'g',
            { transform: 'translate(12, 5)' },
            _react2.default.createElement('circle', { className: 'ax-ghost__eyelid', cx: '5', cy: '5', r: '5' }),
            _react2.default.createElement('circle', { className: 'ax-ghost__eyelid', cx: '21', cy: '5', r: '5' })
          )
        ),
        _react2.default.createElement(
          'g',
          { mask: 'url(#hole)' },
          _react2.default.createElement('rect', {
            className: 'ax-ghost__card',
            height: '100%',
            rx: '3',
            width: '100%',
            x: '0',
            y: '0' }),
          _react2.default.createElement(
            'g',
            { className: 'ax-ghost__text', transform: 'translate(12, 132)' },
            _react2.default.createElement(
              'g',
              null,
              _react2.default.createElement('rect', { height: '6', width: '30', y: '0' }),
              _react2.default.createElement('rect', { height: '6', width: '42', y: '12' }),
              _react2.default.createElement('rect', { height: '6', width: '24', y: '24' }),
              _react2.default.createElement('rect', { height: '6', width: '30', y: '36' })
            ),
            _react2.default.createElement(
              'g',
              { transform: 'translate(78, 0)' },
              _react2.default.createElement('rect', { height: '6', width: '18', x: '12', y: '0' }),
              _react2.default.createElement('rect', { height: '6', width: '30', x: '0', y: '12' }),
              _react2.default.createElement('rect', { height: '6', width: '12', x: '18', y: '24' }),
              _react2.default.createElement('rect', { height: '6', width: '18', x: '12', y: '36' })
            )
          ),
          _react2.default.createElement(
            'g',
            { transform: 'translate(30, 18)' },
            _react2.default.createElement('rect', {
              className: 'ax-ghost__card-title',
              height: '6',
              width: '72',
              x: '0',
              y: '0' }),
            _react2.default.createElement('rect', {
              className: 'ax-ghost__card-subtitle',
              height: '6',
              width: '48',
              x: '12',
              y: '12' })
          ),
          _react2.default.createElement(
            'g',
            { fill: 'transparent', transform: 'translate(30, 48)' },
            _react2.default.createElement('circle', { cx: '36', cy: '36', r: '36' })
          )
        )
      );
    }
  }]);

  return Ghost;
}(_react.Component);

exports.default = Ghost;